import { Alert, Form, Space, Typography } from 'antd'
import React, { useCallback, useEffect, useMemo } from 'react'
import { ToolProjectPhasesMappingAPI } from 'restAPI/ToolsIntegrationAPI'
import { FieldTypes, generateFormFields } from 'utils/formUtils'
import { useGlobalFilterContext } from 'contexts/GlobalFilterContext';
import { API_PHASE_TOOL_NAME, PROJECT_VERSION_PHASES } from './SettingStatusConstant'

const ToolProjectVersionPhase = ({ toolName, handleToolPhaseChange }) => {
    const apiToolName = API_PHASE_TOOL_NAME[toolName]
    const [form] = Form.useForm();
    const { globalFilterHash } = useGlobalFilterContext();

    const fetchData = useCallback(async () => {
        try {
            const resData = await ToolProjectPhasesMappingAPI.getToolProjectPhaseMapping(apiToolName).promise;
            const selectedValue = Object.keys(resData)
            form.setFieldsValue({ phases: selectedValue })
            handleToolPhaseChange(selectedValue);
        } catch (err) {
            console.error(err)
        }
    }, [apiToolName, form, handleToolPhaseChange])

    useEffect(() => {
        fetchData();
    }, [globalFilterHash, fetchData])


    const fields = useMemo(() => [{
        name: "phases",
        label: <Typography.Text>Select {toolName} phases to support ArmorCode Discovery</Typography.Text>,
        placeholder: <Typography.Text>Select {toolName} phases</Typography.Text>,
        type: FieldTypes.MULTI_SELECT,
        options: parseSelectOptions(PROJECT_VERSION_PHASES),
        colSpan: 16,
        props: {
            allowClear: true
        }
    }], [toolName])


    return (
        <Space direction="vertical" className="m-b-m">
            <Alert
                description={
                    <Form
                        form={form}
                        style={{ minWidth: 600 }}
                        layout="vertical"
                        onValuesChange={(values) => {
                            handleToolPhaseChange(values.phases)
                        }}
                    >
                        {generateFormFields(fields)}
                    </Form>
                }
            />
        </Space>
    )
}

export default ToolProjectVersionPhase

const parseSelectOptions = (options = {}) => {
    const selectOption = [];
    Object.keys(options).forEach(key => {
        selectOption.push({ label: options[key], value: key })
    })
    return selectOption;
}
